import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability';

type Actions = 'view' | 'manage' | 'delete';
type Subjects = 'Home' | 'BetaFeature' | 'MasterData' | 'Contract' | 'FishingTrip' | 'Report';

type AppAbilityType = Ability<[Actions, Subjects]>;
const AppAbility = Ability as AbilityClass<AppAbilityType>;

export const initialAbility = [{ action: 'view', subject: 'Home' }];

enum Roles {
    Developer = 'Developer',
    SuperUser = 'SuperUser',
    Administrator = 'Administrator',
    Viewer = 'Viewer',
}

const getRules = (roles: string[]) => {
    const { can, cannot, rules } = new AbilityBuilder(AppAbility);

    if(!roles) {
        cannot('view', 'BetaFeature');
        cannotView();
        cannotManage();
        cannotDelete();
        return rules;
    }

    if (roles.includes(Roles.Developer.toString())) {
        can('view', 'BetaFeature');
        canView();
        canManage();
        canDelete();
    }
    if (roles.includes(Roles.SuperUser.toString())) {
        cannot('view', 'BetaFeature');
        canView();
        canManage();
        canDelete();
    }
    if (roles.includes(Roles.Administrator.toString())) {
        cannot('view', 'BetaFeature');
        canView();
        canManage();
        cannotDelete();
    }
    if (roles.includes(Roles.Viewer.toString())) {
        cannot('view', 'BetaFeature');
        canView();
        cannotManage();
        cannotDelete();
    }
    return rules;

    // helper methods
    function canDelete() {
        can('delete', 'MasterData');
        can('delete', 'Contract');
        can('delete', 'FishingTrip');
    }
    function cannotDelete() {
        cannot('delete', 'MasterData');
        cannot('delete', 'Contract');
        cannot('delete', 'FishingTrip');
    }
    function canManage() {
        can('manage', 'MasterData');
        can('manage', 'Contract');
        can('manage', 'FishingTrip');
    }
    function cannotManage() {
        cannot('manage', 'MasterData');
        cannot('manage', 'Contract');
        cannot('manage', 'FishingTrip');
    }

    function canView() {
        can('view', 'MasterData');
        can('view', 'Contract');
        can('view', 'FishingTrip');
        can('view', 'Report');
    }

    function cannotView() {
        cannot('view', 'MasterData');
        cannot('view', 'Contract');
        cannot('view', 'FishingTrip');
        cannot('view', 'Report');
    }
};

export { getRules };